import React from "react";
import SavingsTab from "./SavingsTab";

/**
 * Shares breakdown on member profile: same table as savings,
 * filtered to category_kind = shares (non-withdrawable capital).
 */
const SharesTab = ({ shares = [], total = 0, memberId = null, isMemberContext = false }) => (
  <SavingsTab
    savings={shares}
    total={total}
    memberId={memberId}
    isMemberContext={isMemberContext}
    kind="shares"
    title="Shares"
    emptyTitle="No shares recorded yet"
    emptyMessage="Share purchases for this member will show up here."
  />
);

export default SharesTab;
